var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmaterialArrowDropDown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.48,
    height: 7.605,
    viewBox: "0 0 12.48 7.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-arrow-drop-down",
    "data-name": "Icon material-arrow-drop-down",
    d: "M22.98,15l-6.24,7.6L10.5,15Z",
    transform: "translate(-10.5 -15)",
    fill: "#B98772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialArrowDropDown1);
export default __webpack_public_path__ + "static/media/Icon material-arrow-drop-down1.de929a72f35a541bf9d6417a207e97fc.svg";
export { ForwardRef as ReactComponent };